////////////////////////////////////////

import axios from "axios";

import base_module from '@/vmm-store/modules/base';
//import vmm_store from '../vmm-store';

//const base_service = vmm_store.service;

const options = {
    model_name    : 'invoice_approval',
    default_order : 'data DESC',
};

const state = {
    params                : {},
    check_all_operator    : false,
    selected_ids_operator : [],
};

const actions = {
    update({ commit, getters, state }, data) {
        commit('start_request');
        var params   = JSON.parse( JSON.stringify( state.params ) );
        console.log( params );
        params.order = getters.order;
        let url = `${ getters.backend_url }/model/${ getters.model_name }/${ data.id }?`;
        Object.keys( params ).map( key => { url += `&${ key }=${ params[ key ] }` });
        axios.patch( url, data.payload )
            .then( res => {
                let response = res.data;
                commit( 'reset_selected_ids_operator' );
                if ( params.paginate === true ) { // gestione paginator
                    commit('success_list', response.data);
                    commit('set_total', response.tot);
                    commit('set_page', response.page);
                    commit('set_rows_per_page', response.rows_per_page);
                } else {
                    commit('success_list', response)
                }
            })
            .catch( error => {
                commit('error', error)
            });
    },
    update_all({ commit, getters, state }, data) {
        commit('start_request');
        var params   = JSON.parse( JSON.stringify( state.params ) );
        params.order = getters.order;
        let url = `${ getters.backend_url }/model/${ getters.model_name }/updateall?`;
        Object.keys( params ).map( key => { url += `&${ key }=${ params[ key ] }` });
        axios.patch( url, data.payload )
            .then( res => {
                let response = res.data;
                commit( 'reset_selected_ids_operator' );
                if ( params.paginate === true ) { // gestione paginator
                    commit('success_list', response.data);
                    commit('set_total', response.tot);
                    commit('set_page', response.page);
                    commit('set_rows_per_page', response.rows_per_page);
                } else {
                    commit('success_list', response)
                }
            })
            .catch( error => {
                commit('error', error)
            });
    },
    set_check_all_operator( { commit }, value ) {
        commit( 'set_check_all_operator', value );
    },
    add_selected_operator( { commit }, id ) {
        commit( 'add_selected_operator', id );
    },
    remove_selected_operator( { commit }, id ) {
        commit( 'remove_selected_operator', id );
    },
    reset_selected_ids_operator( { commit } ) {
        commit( 'reset_selected_ids_operator' );
    },
};

const mutations = {
    set_check_all_operator( state, value ) {
        state.check_all_operator = value;
        state.selected_ids_operator = [];
    },
    add_selected_operator( state, id ) {
        if ( !state.selected_ids_operator.includes( id ) ) {
            state.selected_ids_operator.push( id );
        }
    },
    remove_selected_operator( state, id ) {
        let index = state.selected_ids_operator.indexOf( id );
        if ( index > -1 ) {
            state.selected_ids_operator.splice(index, 1);
        }
        console.log( 'selected_ids', state.selected_ids_operator );
    },
    reset_selected_ids_operator( state ) {
        state.selected_ids_operator = [];
    },
};

const getters = {
    is_selected_operator: ( state ) => ( id ) => {
        return state.selected_ids_operator.includes( id );
    },
};

class new_module extends base_module {

    constructor ( new_options = {} ) {
        Object.keys( new_options ).map( x => {
            options[ x ] = new_options[ x ];
        });
        super( options );
    }

    static get_module( new_options = {} ) {
        var obj = new new_module( new_options );
        return {
            namespaced: true,
            state: {
                ...obj.state,
                ...state,
            },
            getters: {
                ...obj.getters,
                ...getters,
            },
            actions: {
                ...obj.actions,
                ...actions,
            },
            mutations: {
                ...obj.mutations,
                ...mutations,
            },
        }
    }

}

export default new_module;

